import type { ChangeSetState, ReviewSubject } from "../../../api/content/reviewDecoders";
import { appPaths } from "../../../shared/routing/appPaths";

interface Reviewed {
  readonly reviewSubject: ReviewSubject | null;
  readonly changeSet: { readonly changeSetId: string; readonly state: ChangeSetState };
}

/**
 * The Thread step a review is answered in (ADR-0031 D4): its owning step while the change set
 * is open, which is while that step waits. A merged, scrapped or sent-back change set has a
 * settled step that the Thread no longer shows, so its review stays at its address.
 */
export function waitingReviewStep(review: Reviewed): ReviewSubject | null {
  return review.changeSet.state === "open" ? review.reviewSubject : null;
}

/** Where a row opens: the waiting Thread step that decides the change set, else its review address. */
export function reviewAddress(review: Reviewed): string {
  const step = waitingReviewStep(review);
  return step === null ? appPaths.review(review.changeSet.changeSetId) : appPaths.threadStep(step.threadId, step.stepKey);
}
